"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.orderContactFactory = orderContactFactory;
var _get2 = _interopRequireDefault(require("lodash/get"));
/**
 * order contact factory
 * @param {Object} data
 * @returns {Object}
 */
function orderContactFactory(data) {
  return {
    title: (0, _get2.default)(data, 'title', ''),
    firstName: (0, _get2.default)(data, 'firstName', ''),
    lastName: (0, _get2.default)(data, 'lastName', ''),
    email: (0, _get2.default)(data, 'email', ''),
    phone: (0, _get2.default)(data, 'phone', '')
  };
}